/**
 * CoLab Hero Parallax Module
 * Горизонтальний parallax ефект для великого логотипу
 * Логотип рухається зліва направо при скролі
 */

export const HeroParallax = {
    // DOM Elements
    hero: null,
    largeElement: null,

    // Settings
    config: {
        // Діапазон руху (в % від ширини viewport)
        startX: -30,    // Початкова позиція (зліва)
        endX: 30,       // Кінцева позиція (справа)

        // Опціонально: вертикальний рух
        startY: 0,
        endY: 0,

        // Opacity ефект
        fadeOut: true,      // Зменшувати opacity при скролі
        fadeStart: 0.15,    // Початкова opacity
        fadeEnd: 0.02,      // Кінцева opacity

        // Smoothing
        smoothing: 0.1,     // Плавність (0-1, менше = плавніше)

        // Scale ефект (опціонально)
        scaleStart: 1,
        scaleEnd: 0.9
    },

    // State
    currentX: 0,
    targetX: 0,
    currentOpacity: 0.15,
    targetOpacity: 0.15,
    rafId: null,
    isActive: false,

    init: function(options) {
        // Merge options
        if (options) {
            for (var key in options) {
                if (options.hasOwnProperty(key)) {
                    this.config[key] = options[key];
                }
            }
        }

        this.hero = document.querySelector('.hero');
        this.largeElement = document.querySelector('.hero__large');

        if (!this.hero || !this.largeElement) {
            console.log('[CoLab.HeroParallax] Elements not found, skipping init');
            return;
        }

        // Встановлюємо початкові значення
        this.currentX = this.config.startX;
        this.targetX = this.config.startX;
        this.currentOpacity = this.config.fadeStart;

        this.bindEvents();
        this.startAnimation();

        console.log('[CoLab.HeroParallax] Initialized');
    },

    bindEvents: function() {
        var self = this;

        // Scroll handler
        window.addEventListener('scroll', function() {
            self.onScroll();
        }, { passive: true });

        // Initial calculation
        this.onScroll();

        // Resize handler
        window.addEventListener('resize', function() {
            self.onScroll();
        }, { passive: true });
    },

    onScroll: function() {
        var scrollY = window.pageYOffset;
        var heroRect = this.hero.getBoundingClientRect();
        var heroHeight = this.hero.offsetHeight;
        var windowHeight = window.innerHeight;

        // Розраховуємо прогрес скролу через hero секцію
        // 0 = top of hero at top of viewport
        // 1 = bottom of hero at top of viewport
        var scrollStart = this.hero.offsetTop;
        var scrollEnd = scrollStart + heroHeight;

        // Прогрес від 0 до 1
        var progress = (scrollY - scrollStart + windowHeight) / (heroHeight + windowHeight);
        progress = Math.max(0, Math.min(1, progress));

        // Розраховуємо target позицію
        var range = this.config.endX - this.config.startX;
        this.targetX = this.config.startX + (range * progress);

        // Розраховуємо opacity
        if (this.config.fadeOut) {
            var opacityRange = this.config.fadeStart - this.config.fadeEnd;
            this.targetOpacity = this.config.fadeStart - (opacityRange * progress);
        }

        this.isActive = true;
    },

    startAnimation: function() {
        var self = this;

        function animate() {
            self.rafId = requestAnimationFrame(animate);

            if (!self.isActive) return;

            // Smooth interpolation (lerp)
            var smoothing = self.config.smoothing;

            self.currentX += (self.targetX - self.currentX) * smoothing;
            self.currentOpacity += (self.targetOpacity - self.currentOpacity) * smoothing;

            // Застосовуємо transform
            self.largeElement.style.transform =
                'translate(-50%, -50%) translateX(' + self.currentX + 'vw)';

            // Застосовуємо opacity
            if (self.config.fadeOut) {
                self.largeElement.style.opacity = self.currentOpacity;
            }

            // Зупиняємо якщо досягли target
            if (Math.abs(self.targetX - self.currentX) < 0.01) {
                self.isActive = false;
            }
        }

        animate();
    },

    // Public API
    destroy: function() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
        }
        if (this.largeElement) {
            this.largeElement.style.transform = '';
            this.largeElement.style.opacity = '';
        }
    },

    // Оновити конфігурацію
    update: function(newConfig) {
        for (var key in newConfig) {
            if (newConfig.hasOwnProperty(key)) {
                this.config[key] = newConfig[key];
            }
        }
        this.onScroll();
    }
};
